import { render, staticRenderFns } from "./static-card.vue?vue&type=template&id=6f07017c&scoped=true&"
import script from "./static-card.vue?vue&type=script&lang=js&"
export * from "./static-card.vue?vue&type=script&lang=js&"
import style0 from "./static-card.vue?vue&type=style&index=0&id=6f07017c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07017c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f07017c')) {
      api.createRecord('6f07017c', component.options)
    } else {
      api.reload('6f07017c', component.options)
    }
    module.hot.accept("./static-card.vue?vue&type=template&id=6f07017c&scoped=true&", function () {
      api.rerender('6f07017c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/static-card.vue"
export default component.exports